// 配置 AI_GENERATE_PAGE_COMMAND_ID 的地址：
// https://wuji.woa.com/p/edit?appid=tdocs_ai_admin_test&schemaid=ai_modal_command_lib&nsid=_all
// https://wuji.woa.com/p/edit?appid=tdocs_ai_admin&errCode=0&nsid=_all&schemaid=ai_command_lib_modal
export const AI_GENERATE_PAGE_COMMAND_ID = '73';


const DELAY = 150;
let lastKeyBoardHeight = 0;
// AI 浮窗在聚焦后获取键盘高度的函数，
export async function getSoftKeyboardHeightInAiFloat(): Promise<number> {
    const promise = new Promise((resolve) => {
        setTimeout(() => {
            const y = document.documentElement.scrollHeight - (window.visualViewport?.height || 0);
            if (y) {
                lastKeyBoardHeight = y;
                resolve(y);
            } else {
                const onSizeChange = () => {
                    const y2 = document.documentElement.scrollHeight - (window.visualViewport?.height || 0);
                    if (y2) {
                        lastKeyBoardHeight = y2;
                        resolve(y2);
                    }
                    window.visualViewport?.removeEventListener('resize', onSizeChange);
                };
                window.visualViewport?.addEventListener('resize', onSizeChange);
                // 无论如何 150ms 以后都销毁监听函数
                setTimeout(() => {
                    window.visualViewport?.removeEventListener('resize', onSizeChange);
                    resolve(lastKeyBoardHeight);
                }, 150);
            }
        }, DELAY);
    });
    return promise as Promise<number>;
}
